import {OfferPoiType} from "./offer_poi_tags_enum";

/**
 * Display categories for the POI pills. One pill is rendered per category (nearest POI), in
 * OFFER_POI_CATEGORY_ORDER. Bus and tram share the TRANSIT category (per product decision),
 * while park, forest and nature reserve are displayed separately.
 */
export enum OfferPoiCategory {
    RAIL = "rail", // metro / kolej (SKM)
    PARK = "park",
    FOREST = "forest",
    NATURE_RESERVE = "nature-reserve",
    TRANSIT = "transit" // autobus / tramwaj
}

export const OFFER_POI_TYPE_CATEGORY: Record<OfferPoiType, OfferPoiCategory> = {
    [OfferPoiType.METRO]: OfferPoiCategory.RAIL,
    [OfferPoiType.KOLEJ]: OfferPoiCategory.RAIL,
    [OfferPoiType.PARK]: OfferPoiCategory.PARK,
    [OfferPoiType.LAS]: OfferPoiCategory.FOREST,
    [OfferPoiType.REZERWAT]: OfferPoiCategory.NATURE_RESERVE,
    [OfferPoiType.BUS]: OfferPoiCategory.TRANSIT,
    [OfferPoiType.TRAM]: OfferPoiCategory.TRANSIT
};

export const OFFER_POI_CATEGORY_ORDER: OfferPoiCategory[] = [
    OfferPoiCategory.RAIL,
    OfferPoiCategory.PARK,
    OfferPoiCategory.FOREST,
    OfferPoiCategory.NATURE_RESERVE,
    OfferPoiCategory.TRANSIT
];

export const OFFER_POI_TYPE_PRESENTATION: Record<OfferPoiType, {label: string; icon: string}> = {
    [OfferPoiType.METRO]: {label: "Metro", icon: "metro"},
    [OfferPoiType.KOLEJ]: {label: "Kolej", icon: "kolej"},
    [OfferPoiType.BUS]: {label: "Autobus", icon: "bus"},
    [OfferPoiType.TRAM]: {label: "Tramwaj", icon: "tram"},
    [OfferPoiType.PARK]: {label: "Park", icon: "park"},
    [OfferPoiType.LAS]: {label: "Las", icon: "forest"},
    [OfferPoiType.REZERWAT]: {label: "Rezerwat", icon: "nature-reserve"}
};

export const OFFER_POI_SKM_CITIES = ["Warszawa", "Gdynia", "Gdańsk", "Sopot"];
export const OFFER_POI_KOLEJ_SKM_LABEL = "Stacja SKM";
import {OfferPoiType} from "./offer_poi_tags_enum";

/**
 * Display categories for the POI pills. One pill is rendered per category (nearest POI), in
 * OFFER_POI_CATEGORY_ORDER. Bus and tram share the TRANSIT category (per product decision),
 * while park, forest and nature reserve are displayed separately.
 */
export enum OfferPoiCategory {
    RAIL = "rail", // metro / kolej (SKM)
    PARK = "park",
    FOREST = "forest",
    NATURE_RESERVE = "nature-reserve",
    TRANSIT = "transit" // autobus / tramwaj
}

export const OFFER_POI_TYPE_CATEGORY: Record<OfferPoiType, OfferPoiCategory> = {
    [OfferPoiType.METRO]: OfferPoiCategory.RAIL,
    [OfferPoiType.KOLEJ]: OfferPoiCategory.RAIL,
    [OfferPoiType.PARK]: OfferPoiCategory.PARK,
    [OfferPoiType.LAS]: OfferPoiCategory.FOREST,
    [OfferPoiType.REZERWAT]: OfferPoiCategory.NATURE_RESERVE,
    [OfferPoiType.BUS]: OfferPoiCategory.TRANSIT,
    [OfferPoiType.TRAM]: OfferPoiCategory.TRANSIT
};

export const OFFER_POI_CATEGORY_ORDER: OfferPoiCategory[] = [
    OfferPoiCategory.RAIL,
    OfferPoiCategory.PARK,
    OfferPoiCategory.FOREST,
    OfferPoiCategory.NATURE_RESERVE,
    OfferPoiCategory.TRANSIT
];

export const OFFER_POI_TYPE_PRESENTATION: Record<OfferPoiType, {label: string; icon: string}> = {
    [OfferPoiType.METRO]: {label: "Metro", icon: "metro"},
    [OfferPoiType.KOLEJ]: {label: "Kolej", icon: "kolej"},
    [OfferPoiType.BUS]: {label: "Autobus", icon: "bus"},
    [OfferPoiType.TRAM]: {label: "Tramwaj", icon: "tram"},
    [OfferPoiType.PARK]: {label: "Park", icon: "park"},
    [OfferPoiType.LAS]: {label: "Las", icon: "forest"},
    [OfferPoiType.REZERWAT]: {label: "Rezerwat", icon: "nature-reserve"}
};

export const OFFER_POI_SKM_CITIES = ["Warszawa", "Gdynia", "Gdańsk", "Sopot"];
export const OFFER_POI_KOLEJ_SKM_LABEL = "Stacja SKM";
